// extracted by mini-css-extract-plugin
module.exports = {"modal__img":"family-module__modal__img___V75AM"};